import { render, staticRenderFns } from "./parametro.vue?vue&type=template&id=2b388375&scoped=true"
import script from "./parametro.vue?vue&type=script&lang=js"
export * from "./parametro.vue?vue&type=script&lang=js"
import style0 from "./parametro.vue?vue&type=style&index=0&id=2b388375&prod&lang=scss&scoped=true"
import style1 from "./parametro.vue?vue&type=style&index=1&id=2b388375&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b388375",
  null
  
)

export default component.exports